module.exports = __webpack_public_path__ + "img/english.a7fc19d7.png";